import { CARD_RUNS_LABEL } from '../domain/catalog';
import type { SectionCounts } from '../types';

interface SectionHeaderProps {
  title: string;
  desc: string;
  counts: SectionCounts;
  folded: boolean;
  onToggleFold: () => void;
  /** Absent on a board-only section, where a registered card would have nowhere to live. */
  onAddManagedSkill?: (() => void) | undefined;
}

/** Read-only section title row with the managed-skill registration exception. */
const SectionHeader = ({ title, desc, counts, folded, onToggleFold, onAddManagedSkill }: SectionHeaderProps) => (
  <div className="fsec-h">
    <button className="fold-btn" type="button" aria-expanded={!folded} title="Fold section" onClick={onToggleFold}>
      <svg viewBox="0 0 16 16" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M4 6l4 4 4-4" />
      </svg>
    </button>
    <span className="fsec-t">{title}</span>
    <span className="fsec-d">{desc}</span>
    <span className="fsec-n">
      {counts.agents === 0 ? (
        '0 agents'
      ) : (
        <>
          <b>{counts.agents}</b> agents · <b>{counts.active}</b> active · <b>{counts.runs}</b> {CARD_RUNS_LABEL}
          {counts.issues > 0 ? (
            <>
              {' · '}
              <b className="iss">{counts.issues}</b> issue{counts.issues > 1 ? 's' : ''}
            </>
          ) : null}
        </>
      )}
    </span>
    {onAddManagedSkill ? (
      <button className="fsec-add" type="button" title="Add managed skill" onClick={onAddManagedSkill}>
        +
      </button>
    ) : null}
  </div>
);

export default SectionHeader;
